import axios from "axios";
export default async function SearchAirports(location) {
    const options = {
      method: "GET",
      url: "https://sky-scrapper.p.rapidapi.com/api/v1/flights/searchAirport",
      params: {
        query: location, // this one should be give by the user let's say
        locale: "en-US",
      },
      headers: {
        "x-rapidapi-key": process.env.REACT_APP_RAPIDAPI_KEY,
        "x-rapidapi-host": process.env.REACT_APP_RAPIDAPI_HOST,
      },
    };

  try {
  //  const response = await axios.request(options);
  const response = {
    status: true,
    timestamp: 1691008938320,
    data: [
      {
        presentation: {
          title: "New York",
          suggestionTitle: "New York (Any)",
          subtitle: "United States",
        },
        navigation: {
          entityId: "27537542",
          entityType: "CITY",
          localizedName: "New York",
          relevantFlightParams: {
            skyId: "NYCA",
            entityId: "27537542",
            flightPlaceType: "CITY",
            localizedName: "New York",
          },
          relevantHotelParams: {
            entityId: "27537542",
            entityType: "CITY",
            localizedName: "New York",
          },
        },
      },
      {
        presentation: {
          title: "New York Newark",
          suggestionTitle: "New York Newark (EWR)",
          subtitle: "United States",
        },
        navigation: {
          entityId: "95565059",
          entityType: "AIRPORT",
          localizedName: "New York Newark",
          relevantFlightParams: {
            skyId: "EWR",
            entityId: "95565059",
            flightPlaceType: "AIRPORT",
            localizedName: "New York Newark",
          },
          relevantHotelParams: {
            entityId: "27537542",
            entityType: "CITY",
            localizedName: "New York",
          },
        },
      },
      {
        presentation: {
          title: "New York John F. Kennedy",
          suggestionTitle: "New York John F. Kennedy (JFK)",
          subtitle: "United States",
        },
        navigation: {
          entityId: "95565058",
          entityType: "AIRPORT",
          localizedName: "New York John F. Kennedy",
          relevantFlightParams: {
            skyId: "JFK",
            entityId: "95565058",
            flightPlaceType: "AIRPORT",
            localizedName: "New York John F. Kennedy",
          },
          relevantHotelParams: {
            entityId: "27537542",
            entityType: "CITY",
            localizedName: "New York",
          },
        },
      },
      {
        presentation: {
          title: "New York LaGuardia",
          suggestionTitle: "New York LaGuardia (LGA)",
          subtitle: "United States",
        },
        navigation: {
          entityId: "95565057",
          entityType: "AIRPORT",
          localizedName: "New York LaGuardia",
          relevantFlightParams: {
            skyId: "LGA",
            entityId: "95565057",
            flightPlaceType: "AIRPORT",
            localizedName: "New York LaGuardia",
          },
          relevantHotelParams: {
            entityId: "27537542",
            entityType: "CITY",
            localizedName: "New York",
          },
        },
      },
      {
        presentation: {
          title: "Stewart International",
          suggestionTitle: "Stewart International (SWF)",
          subtitle: "United States",
        },
        navigation: {
          entityId: "95566280",
          entityType: "AIRPORT",
          localizedName: "Stewart International",
          relevantFlightParams: {
            skyId: "SWF",
            entityId: "95566280",
            flightPlaceType: "AIRPORT",
            localizedName: "Stewart International",
          },
          relevantHotelParams: {
            entityId: "27537542",
            entityType: "CITY",
            localizedName: "New York",
          },
        },
      },
    ],
  };
    return response;
  } catch (error) {
    console.error(error);
  }
}
